import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement } from 'chart.js/auto';import { formatoMoneda } from '../../configuracion/validaciones';
 ChartJS.register(ArcElement);

const Circular = ({ datos, esMonetario }) => {
  // 1. Calculamos el total sumando todos los valores del array
  const total = datos.data.reduce((sum, valor) => sum + valor, 0);

  // 2. Convertimos el array original de números a un array de porcentajes
  const datosEnPorcentaje = datos.data.map(valor => {
    return ((valor / total) * 100).toFixed(1); // Deja 1 decimal (ej: 33.3)
  });
  const data = {
    labels: datos.labels,
    datasets: [
      {
        data: datosEnPorcentaje,
        backgroundColor: datos.colors,
        borderRadius: 6,       // <- Bordes redondeados
        spacing: 4,            // <- Espacio entre bloques
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: '50%',
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          padding: 20,         // Despega las etiquetas del gráfico
          usePointStyle: true, // Cambia los rectángulos de la leyenda por círculos
        }
      },
      title: {
        display: true,
        text: datos.titulo,
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.8)', // Fondo oscuro personalizado
        callbacks: {
          // Modifica lo que dice el tooltip
          label: function (context) {
            let label = context.label || '';
            let value = context.raw || 0;
            return ` ${label}: ${ value } %`; // Ej: "Ventas: $500 USD"
          }
        }
      },
    },
    animation: {
      animateScale: true,      // <- Animación de crecimiento al cargar
    }
  };
  return (
    <>
      <Doughnut data={data} options={options} />
    </>

  );
}

export default Circular;
